import React from "react";
import "./styles.css";

const Line = ({ type = "horizontal"}) => {
  return(
    <div className={`line ${type}`}></div>
  );
};

export default Line;